import React from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  useWindowDimensions,
  Text,
  FlatList,
} from "react-native";

import { SessionContext } from "../../../../contexts";
import { TitleText } from "../../../common/native";
import {
  getAppointmentsForClinic,
  TListAppointmentResponse,
} from "../../../../services/api-appointment";

const HomeAppointments: React.FC = () => {
  const session = React.useContext(SessionContext)?.session;
  const [appointments, setAppointments] = React.useState<
    TListAppointmentResponse[]
  >([]);
  const [hasFetched, setHasFetched] = React.useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width < 644;

  React.useEffect(() => {
    const fetchAppointments = async () => {
      if (!session) return;
      try {
        const appts = await getAppointmentsForClinic(session);
        setAppointments(appts);
      } catch (error) {
        console.error("Error fetching clinic appointments:", error);
      } finally {
        setHasFetched(true);
      }
    };

    fetchAppointments();
  }, [session]);

  if (!session) return null;

  const renderItem = ({ item }: { item: TListAppointmentResponse }) => (
    <View style={styles.row}>
      <Text style={styles.cell}>{new Date(item.date).toLocaleString()}</Text>
      <Text style={styles.cell}>{item.type}</Text>
      <Text style={styles.cell}>{item.reason}</Text>
      <Text style={styles.cell}>
        {item.formatted_procedures?.join(", ") || ""}
      </Text>
      <Text style={styles.cell}>
        {item.unformatted_procedures?.join(", ") || ""}
      </Text>
      <Text style={styles.cell}>{item.notes || ""}</Text>
      <Text style={styles.cell}>{item.external_id || ""}</Text>
    </View>
  );

  return (
    <ScrollView style={styles.container}>
      <TitleText text="Appointments" style={styles.title} />
      <ScrollView horizontal>
        <View style={styles.tableContainer}>
          <View style={[styles.row, styles.headerRow]}>
            <Text style={[styles.cell, styles.headerCell]}>Date</Text>
            <Text style={[styles.cell, styles.headerCell]}>Type</Text>
            <Text style={[styles.cell, styles.headerCell]}>Reason</Text>
            <Text style={[styles.cell, styles.headerCell]}>
              Formatted Procedures
            </Text>
            <Text style={[styles.cell, styles.headerCell]}>
              Unformatted Procedures
            </Text>
            <Text style={[styles.cell, styles.headerCell]}>Notes</Text>
            <Text style={[styles.cell, styles.headerCell]}>External ID</Text>
          </View>
          <FlatList
            data={appointments}
            keyExtractor={(item) => item.id.toString()}
            renderItem={renderItem}
          />
        </View>
      </ScrollView>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 10,
    backgroundColor: "#fff",
  },
  title: {
    marginBottom: 12,
  },
  tableContainer: {
    minWidth: 1200,
    paddingBottom: 30,
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    paddingVertical: 8,
  },
  cell: {
    flex: 1,
    paddingHorizontal: 6,
    fontSize: 12,
  },
  headerRow: {
    backgroundColor: "#f0f0f0",
  },
  headerCell: {
    fontWeight: "bold",
  },
});

export default HomeAppointments;
